import styled from 'styled-components';

export const Frame = styled.div`
	width: 43.3125rem;
	max-width: 100%;
	height: 25.875rem;
	margin: 0 auto;
	overflow: hidden;
	background: ${({ theme }) => theme.palette.secondary[400]};
	border-radius: 1rem;
`;

export const Video = styled.video`
	display: block;
	width: 100%;
	height: 100%;
	object-fit: cover;
	pointer-events: none;
`;
